import axios from "axios";

export default {
    namespaced: true,

    state: {
        access_token: localStorage.getItem("access_token"),
        user: null,
        token: null,
    },

    mutations: {
        getProfileSuccess(state, user) {
            state.user = user;
            if (user?.customer) {
                this.state.customer.customer = user.customer;
            }
            if (user?.employee) {
                this.state.employee.employee = user.employee;
            }
        },

        loginSuccess(state, data) {
            state.token = data.token;
            localStorage.setItem("access_token", data.token);
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + data.token;
        },

        logoutSuccess(state) {
            state.user = null;
            state.access_token = null;
            this.state.common.locations = null;
            this.state.common.services = null;
            this.state.common.employees = null;
            this.state.common.serviceWorkflows = null;
            this.state.common.roles = null;
            this.state.common.brands = null;
            this.state.common.manufacturers = null;
            this.state.common.stockMovementTypes = null;
            this.state.common.examSampleStatuses = null;
            this.state.common.itemGroups = null;
            this.state.common.permissionActions = null;

            this.state.permission.actionGroups = null;

            this.state.serviceWorkflow.equationClass = null;

            this.state.schedule.services = null;
            this.state.schedule.categoriesServices = null;

            this.state.employee.roles = null;
            this.state.employee.employee = null;

            // conversations
            this.state.conversation.unreadMessages = 0;
            this.state.conversation.queries = {
                page: 1,
            };

            this.state.doctor.customers = null;

            this.state.medicoRolTussCode.authorizationItems = null;

            localStorage.removeItem("access_token");
            localStorage.removeItem("pathToLoadAfterLogin");

            delete axios.defaults.headers.common["Authorization"];
        },
    },

    actions: {
        getProfile({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/profile")
                    .then((res) => {
                        commit("getProfileSuccess", res.data.data.user);
                        resolve(res.data.data.user);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        login({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/login", credentials)
                    .then((res) => {
                        if (!res.data?.data?.two_factor_token_sent) {
                            commit("loginSuccess", res.data.data);
                        }
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getNewTwoFactorCode({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/new_authentication_code", credentials)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        loginWithAuthenticationCode({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/login_with_two_factor_code", credentials)
                    .then((res) => {
                        commit("loginSuccess", res.data.data);
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        register({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/register", credentials)
                    .then((res) => {
                        commit("loginSuccess", res.data.data);
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        registerFreeAccount({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/register_free_account", payload)
                    .then((res) => {
                        commit("loginSuccess", res.data.data);
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        forgotPassword({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/passwords/reset", credentials)
                    .then((res) => {
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        changePassword({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/passwords/change", credentials)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        logout({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/logout")
                    .then((res) => {
                        commit("logoutSuccess");
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        switchRole({ commit }, role) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/switch-role", { role: role })
                    .then((res) => {
                        commit("getProfileSuccess", res.data.data.user);
                        resolve(res.data.data.user);
                    })
                    .catch((err) => {
                        reject(error);
                    });
            });
        },

        switchAccount({ commit }, account_id) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(`/switch-account/${account_id}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(error);
                    });
            });
        },
    },

    getters: {
        isLoggedIn: (state) => !!state.access_token,
        user: (state) => state.user,
    },
};
